import { Add } from '@mui/icons-material';
import { Button, Container, Grid, Paper } from '@mui/material';
import { Subheader } from 'components';
import InPersonEventItem from './InPersonEventItem';
import { useNavigate } from 'react-router-dom';
import { useInPersonEvents } from 'hooks';
import { useEffect } from 'react';

const InPersonEventList = () => {
	const { fetchInPersonEvents, inPersonEvents } = useInPersonEvents({
		id: undefined
	});
	const navigate = useNavigate();

	const handleAddClick = () => navigate('/in-person-events/new');

	useEffect(() => {
		fetchInPersonEvents();
	}, []);
	return (
		<div>
			<Subheader
				title="In-Person Events"
				buttons={[
					<Button
						variant="contained"
						startIcon={<Add />}
						onClick={handleAddClick}
						color="primary"
					>
						Event
					</Button>
				]}
			/>

			<Container maxWidth="xl" className="custom-Mul-Container">
				<Paper style={{ padding: 24, minHeight: '70vh' }}>
					<Grid container spacing={1}>
						{inPersonEvents.map((inPersonEvent) => (
							<InPersonEventItem inPersonEvent={inPersonEvent} />
						))}
					</Grid>
				</Paper>
			</Container>
		</div>
	);
};

export default InPersonEventList;
